import { manufacturer as manufacturerFilter } from '@/modules/standardItems/schemas/baseFilters'
import {
  name,
  manufacturer,
  manufacturerNumber,
  computerEaseNumber
} from '@/modules/standardItems/schemas/baseHeaders'

export default {
  id: 'default',
  name: 'Default Item Type Config',
  filters: [
    manufacturerFilter()
  ],
  headers: [
    name(),
    manufacturer(),
    manufacturerNumber(),
    computerEaseNumber()
  ]
}
